import { i18n } from "../utils/i18n";

export default {
  TRIAL_SERVICES: {
    "/iaas-cloud": "cloud_server",
    "/auto-scaling": "cloud_server",
    "/mail-inbox": "mail_inbox",
    "/kubernetes-engine": "kubernetes_engine",
    "/simple-storage": "simple_storage",
    "/cdn": "cdn",
    "/loadbalancers": "load_balancer",
    "/vpnaas": "vpn",
    "/container-registry": "container_registry",
    "/cloud-storage": "cloud_storage",
    "/alert": "cloud_watch",
    "/anti-ddos": "ddos",
    "/iam": "media_fullstack",
    "/vod": "vod",
    "/kas": "kas",
    "/api-gateway": "api_gateway",
    "/cloud-database": "dbaas",
    "/tfm": "traffic_manager",
    "/app-engine": "app_engine",
    "/call-center": "call_center",
    "/waf": "web_application_firewall",
    "/observability": "observability",
  },
  TEMP_BALANCE_SERVICES: {
    "/iaas-cloud": "cloud_server",
    "/auto-scaling": "auto-scaling",
    "/mail-inbox": "mail_inbox",
    "/kubernetes-engine": "kubernetes_engine",
    "/simple-storage": "simple_storage",
    "/cdn": "cdn",
    "/loadbalancers": "load_balancer",
    "/vpnaas": "vpn",
    "/container-registry": "container_registry",
    "/cloud-storage": "cloud_storage",
    "/anti-ddos": "ddos",
    "/iam": "media_fullstack",
    "/vod": "vod",
    "/kas": "kas",
    "/api-gateway": "api_gateway",
    "/cloud-database": "dbaas",
    "/cloud-backup": "cloud_backup",
    "/livestream": "livestream",
    "/security": "security",
    "/sysadmin": "sysadmin",
    "/call-center": "call_center",
    "/cloud-drive": "drive",
    "/alert": "cloud_watcher",
    "/tfm": "traffic_manager",
    "/waf": "web_application_firewall",
  },
  WHITELIST_SERVICES: {
    "/iaas-cloud": "iaas-cloud",
    "/auto-scaling": "iaas-cloud",
    "/mail-inbox": "mail-inbox",
    "/kubernetes-engine": "kubernetes_engine",
    "/simple-storage": "simple-storage",
    "/cdn": "cdn",
    "/loadbalancers": "loadbalancers",
    "/vpnaas": "vpn",
    "/container-registry": "container_registry",
    "/cloud-storage": "cloud_storage",
    "/anti-ddos": "ddos",
    "/vod": "vod",
    "/kas": "kas",
    "/cloud-database": "dbaas",
    "/call-center": "call_center",
    "/waf": "web_application_firewall",
  },
  PROMOTION_SERVICES: {
    "/auto-scaling": "cloud_server",
    "/cdn": "cdn",
    "/call-center": "call_center",
    "/cloud-backup": "cloud_backup",
    "/iaas-cloud": "cloud_server",
    "/cloud-storage": "cloud_storage",
    "/alert": "cloud_watcher",
    "/container-registry": "container_registry",
    "/cloud-database": "dbaas",
    "/anti-ddos": "ddos",
    "/kas": "kas",
    "/kubernetes-engine": "kubernetes_engine",
    "/livestream": "livestream",
    "/loadbalancers": "load_balancer",
    "/mail-inbox": "mail_inbox",
    "/iam": "media_fullstack",
    "/simple-storage": "simple_storage",
    "/vpnaas": "vpn",
    "/vod": "vod",
    "/api-gateway": "api_gateway",
    "/security": "security",
    "/sysadmin": "sysadmin",
    "/cloud-drive": "drive",
    "/tfm": "traffic_manager",
    "/lambda": "lambda",
    "/waf": "web_application_firewall",
  },
  NAME_SERVICES: {
    "/auto-scaling": "Auto Scaling",
    "/cdn": "CDN",
    "/call-center": "Call Center",
    "/cloud-backup": "Cloud Backup",
    "/iaas-cloud": "Cloud Server",
    "/cloud-storage": "Cloud Storage",
    "/alert": "Cloud Watcher",
    "/container-registry": "Container Registry",
    "/cloud-database": "Cloud Database",
    "/anti-ddos": "Anti Ddos",
    "/kas": "Kas",
    "/kubernetes-engine": "Kubernetes Engine",
    "/livestream": "Livestream",
    "/loadbalancers": "Load Balancer",
    "/mail-inbox": "Business Email",
    "/iam": "IAM",
    "/simple-storage": "Simple Storage",
    "/vpnaas": "VPN",
    "/vod": "Video On Demand",
    "/api-gateway": "API Gateway",
    "/security": "Security",
    "/sysadmin": "Sysadmin",
    "/cloud-drive": "Cloud Drive",
    "/lms": "Website LMS",
    "/tfm": "Bizfly Cloud Traffic Manager",
    "/lambda": "Lambda",
    "/waf": "WAF",
    "/observability": "Observability",
  },
  NO_PAYMENT_SERVICES: ["/mail-inbox"],
  IAM_SERVICES: [
    "/iaas-cloud",
    "/loadbalancers",
    "/auto-scaling",
    "/cdn",
    "/kubernetes-engine",
    "/cloud-database",
    "/monitoring",
    "/simple-storage",
    "/container-registry",
    "/mps",
    "/tfm",
    "/dns",
    "/vpnaas",
    "/vod",
    "/alert",
    "/al",
    "/observability",
  ],
  ACTIVE_TRIAL_MANUAL: [
    "/iaas-cloud",
    "/loadbalancers",
    "/auto-scaling",
    "/kubernetes-engine",
    "/simple-storage",
    "/cdn",
    "/vpnaas",
  ],
  ALLOW_SHOW_PERMISSION_DIALOG_WITH_GET_ENDPOINT: [
    {
      service: "kubernetes-engine",
      endpoint: "kubeconfig",
    },
  ],
  DISABLE_SERVICES_ACTION: {
    "/dashboard": [
      { redirect: false, notify: false, status: "all", method: "all" },
    ],
    "/mail-inbox": [
      { redirect: false, notify: false, status: 404, method: "all" },
      { redirect: false, notify: true, status: 422, method: "all" },
    ],
    "/simple-storage": [
      { redirect: false, notify: false, status: 404, method: "all" },
      { redirect: false, notify: false, status: 403, method: "all" },
    ],
    "/cloud-backup": [
      { redirect: false, notify: true, status: "all", method: "all" },
    ],
    "/iaas-cloud": [
      { redirect: false, notify: false, status: 403, method: "all" },
    ],
    "/kubernetes-engine": [
      { redirect: false, notify: false, status: 403, method: "all" },
    ],
    "/loadbalancers": [
      { redirect: false, notify: false, status: 403, method: "all" },
    ],
    "/call-center": [
      { redirect: false, notify: true, status: "all", method: "all" },
    ],
    "/app-engine": [
      { redirect: false, notify: true, status: "all", method: "all" },
    ],
    "/auto-scaling": [
      { redirect: false, notify: false, status: 403, method: "all" },
    ],
    "/cdn": [{ redirect: false, notify: false, status: 403, method: "all" }],
    "/cloud-storage": [
      { redirect: false, notify: false, status: 400, method: "all" },
      { redirect: false, notify: false, status: 422, method: "all" },
    ],
  },
  DISABLE_REQUESTS_ACTION: {
    // dashboard
    "/account/api/sales": [
      { redirect: false, notify: false, status: "all", method: "all" },
    ],
    "/account/api/coupons": [
      { redirect: false, notify: false, status: "all", method: "all" },
    ],
    "/account/api/verification": [
      { redirect: false, notify: false, status: "all", method: "all" },
    ],
    "/account/api/phone": [
      { redirect: false, notify: false, status: "all", method: "all" },
    ],
    "/account/api/password": [
      { redirect: false, notify: true, status: "all", method: "all" },
    ],
    "/account/api/2fa": [
      { redirect: false, notify: true, status: "all", method: "all" },
    ],
    "/api/ssl/certificate_container": [
      { redirect: false, notify: true, status: 400, method: "post" },
      { redirect: false, notify: true, status: "all", method: "all" },
    ],
    "/account/api/credential": [
      { redirect: false, notify: true, status: "all", method: "all" },
    ],
    "/iaas-cloud/api/keypairs": [
      { redirect: false, notify: true, status: "all", method: "all" },
    ],
    // iam
    "/api/iam/v2/projects": [
      { redirect: false, notify: false, status: "all", method: "all" },
    ],
    "/api/iam/v1/projects": [
      { redirect: false, notify: false, status: "all", method: "all" },
    ],
    "/api/iam/v2/role": [
      { redirect: false, notify: false, status: "all", method: "all" },
    ],
    // coupon billing
    "/api/v4.1/apply_coupons": [
      { redirect: false, notify: false, status: "all", method: "all" },
    ],
    // auto-scaling group
    "/api/auto-scaling/groups": [
      { redirect: false, notify: false, status: "all", method: "all" },
    ],
    // waf policy
    "/api/waf/policy": [
      { redirect: false, notify: true, status: "all", method: "all" },
    ],
    "/api/waf/check_domain": [
      { redirect: false, notify: false, status: 422, method: "post" },
    ],
    //cloud watcher
    "/api/alert/utils/ping": [
      { redirect: false, notify: true, status: "all", method: "all" },
    ],
    "/api/alert/sms_packages": [
      { redirect: false, notify: true, status: "all", method: "all" },
    ],
    "/api/alert/alarms": [
      { redirect: false, notify: true, status: "all", method: "all" },
    ],
    // cdn domains
    "/users/domains": [
      { redirect: false, notify: true, status: "all", method: "post" },
    ],
    // vpn
    "/api/vpnaas/vpn_connection": [
      { redirect: false, notify: false, status: 403, method: "post" },
    ],
    // vod
    "/api/vod/store/domains": [
      { redirect: false, notify: true, status: "all", method: "post" },
    ],
    //cdn
    "/config-webp": [
      { redirect: false, notify: true, status: 400, method: "post" },
    ],
    //cloud drive
    "/cloud-storage/api/drive": [
      { redirect: false, notify: false, status: 422, method: "post" },
      { redirect: false, notify: false, status: 403, method: "post" },
      { redirect: false, notify: false, status: 409, method: "post" },
      { redirect: false, notify: false, status: 400, method: "post" },
    ],
    "/cloud-storage/drive": [
      { redirect: false, notify: false, status: 422, method: "post" },
      { redirect: false, notify: false, status: 403, method: "post" },
      { redirect: false, notify: false, status: 409, method: "post" },
      { redirect: false, notify: false, status: 400, method: "post" },
    ],
    //call center
    "/api/call-center/hotlines": [
      { redirect: false, notify: false, status: 404, method: "get" },
    ],
    "/api/call-center/queues": [
      { redirect: false, notify: false, status: 404, method: "get" },
    ],
    // container registry
    "/container-registry/api/_/": [
      { redirect: false, notify: false, status: 422, method: "post" },
      { redirect: false, notify: false, status: 403, method: "post" },
      { redirect: false, notify: false, status: 422, method: "delete" },
      { redirect: false, notify: false, status: 409, method: "delete" },
    ],
    //MPS
    "/mps/api/cdn": [
      { redirect: false, notify: false, status: "all", method: "all" },
    ],
    "mps/api/namespaces": [
      { redirect: false, notify: false, status: "all", method: "post" },
      { redirect: false, notify: false, status: "all", method: "get" },
    ],
    // request from github
    "api.github.com": [
      { redirect: false, notify: false, status: "all", method: "get" },
    ],
  },
  PRIVATE_REGIONS: ["vc-hanoi", "vc-hcm"],
  HOTLINE: "024 7302 8888",
  SUGGESTION_REGION: {
    HN1: "HaNoi",
    HN2: "HaNoi",
    "VC-HaNoi-HN1": "VC-HaNoi",
    "VC-HaNoi-HN2": "VC-HaNoi",
    HCM1: "HoChiMinh",
  },
  STANDARD: [
    {
      ram: 1,
      cpu: 1,
      disk_size: 20,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
    {
      ram: 2,
      cpu: 1,
      disk_size: 20,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
    {
      ram: 2,
      cpu: 2,
      disk_size: 40,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
    {
      ram: 4,
      cpu: 2,
      disk_size: 40,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
    {
      ram: 4,
      cpu: 4,
      disk_size: 40,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
    {
      ram: 6,
      cpu: 4,
      disk_size: 40,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
    {
      ram: 8,
      cpu: 6,
      disk_size: 40,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
  ],
  WINDOWS_STANDARD: [
    {
      ram: 1,
      cpu: 1,
      disk_size: 40,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
    {
      ram: 2,
      cpu: 1,
      disk_size: 40,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
    {
      ram: 2,
      cpu: 2,
      disk_size: 40,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
    {
      ram: 4,
      cpu: 2,
      disk_size: 40,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
    {
      ram: 4,
      cpu: 4,
      disk_size: 40,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
    {
      ram: 6,
      cpu: 4,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
    {
      ram: 8,
      cpu: 6,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "standard",
    },
  ],
  OPTIMIZED: [
    {
      ram: 8,
      cpu: 8,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "optimized",
    },
    {
      ram: 12,
      cpu: 8,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "optimized",
    },
    {
      cpu: 12,
      ram: 16,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "optimized",
    },
    {
      cpu: 16,
      ram: 16,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "optimized",
    },
    {
      cpu: 16,
      ram: 24,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "optimized",
    },
    {
      cpu: 24,
      ram: 64,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "optimized",
    },
    {
      cpu: 32,
      ram: 64,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "optimized",
    },
    {
      cpu: 32,
      ram: 128,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "optimized",
    },
  ],
  BASIC_OPTIMIZED: [
    {
      ram: 8,
      cpu: 8,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "optimized",
    },
    {
      ram: 12,
      cpu: 8,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "optimized",
    },
    {
      cpu: 12,
      ram: 16,
      disk_size: 60,
      data_transfer: i18n?.t("shared.unlimited"),
      type: "optimized",
    },
  ],
  OPTIONS_CONFIG_CPU_RAM: {
    1: [1, 2, 3, 4],
    2: [1, 2, 3, 4, 6, 8],
    3: [2, 3, 4, 6, 8, 12],
    4: [2, 3, 4, 6, 8, 10, 12, 16],
    6: [3, 4, 6, 8, 12, 16, 24],
    8: [3, 4, 6, 8, 12, 16, 24, 32, 48, 64],
    12: [6, 8, 12, 16, 24, 32, 48, 64],
    16: [8, 12, 16, 24, 32, 48, 64],
    24: [12, 16, 24, 32, 48, 64],
    32: [64, 128],
  },
  BASIC_OPTIONS_CONFIG_CPU_RAM: {
    1: [1, 2, 3, 4],
    2: [1, 2, 3, 4, 6, 8],
    3: [2, 3, 4, 6, 8, 12],
    4: [2, 3, 4, 6, 8, 12, 16],
    6: [3, 4, 6, 8, 12, 16, 24],
    8: [3, 4, 6, 8, 12, 16, 24, 32],
    12: [6, 8, 12, 16, 24, 32, 48],
  },
  DEFAULT_CPU_MAX: 2,
  DEFAULT_RAM_MAX: 2,
  DEFAULT_DISK_MAX: 40,
  DEFAULT_CPU_MIN: 1,
  DEFAULT_RAM_MIN: 1,
  DEFAULT_DISK_MIN: 1,
  TRIAL_CPU_MAX: 2,
  TRIAL_RAM_MAX: 2,
  DEFAULT_ACTION_RULES: [
    {
      value: "set_request_header",
      label: "Set request header",
    },
    {
      value: "set_response_header",
      label: "Set response header",
    },
    {
      value: "set_bypass_cache",
      label: "By pass cache",
    },
    {
      value: "redirect",
      label: "Redirect",
    },
  ],
  CUSTOM_ACTION_RULES: [
    {
      value: "rewrite",
      label: "Rewrite",
    },
    {
      value: "set_request_header",
      label: "Set request header",
    },
    {
      value: "set_response_header",
      label: "Set response header",
    },
    {
      value: "set_bypass_cache",
      label: "By pass cache",
    },
    {
      value: "access_deny",
      label: "Access deny",
    },
    {
      value: "redirect",
      label: "Redirect",
    },
    {
      value: "origin_group_override",
      label: "Origin group override",
    },
    {
      value: "set_ttl",
      label: "Time to live",
    },
  ],
  CUSTOM_CONDITION_RULES: [
    {
      value: "path",
      label: "Path",
    },
    {
      value: "header",
      label: "Header",
    },
    {
      value: "cookie",
      label: "Cookie",
    },
    {
      value: "device",
      label: "Device",
    },
    {
      value: "request_method",
      label: "Request method",
    },
    {
      value: "protocol",
      label: "Protocol",
    },
    {
      value: "is_block_by_field",
      label: "Client ip",
    },
  ],
  CONDITIONAL_PATH_OPERATORS: [
    {
      value: "start",
      label: "Start with",
    },
    {
      value: "not_start",
      label: "Not start with",
    },
    {
      value: "end",
      label: "End with",
    },
    {
      value: "not_end",
      label: "Not end with",
    },
    {
      value: "contain",
      label: "Contain",
    },
    {
      value: "not_contain",
      label: "Not contain",
    },
    {
      value: "equal",
      label: "Equal",
    },
    {
      value: "not_equal",
      label: "Not equal",
    },
  ],
  CONDITIONAL_HEADER_OPERATORS: [
    {
      value: "start",
      label: "Start with",
    },
    {
      value: "not_start",
      label: "Not start with",
    },
    {
      value: "end",
      label: "End with",
    },
    {
      value: "not_end",
      label: "Not end with",
    },
    {
      value: "contain",
      label: "Contain",
    },
    {
      value: "not_contain",
      label: "Not contain",
    },
    {
      value: "equal",
      label: "Equal",
    },
    {
      value: "not_equal",
      label: "Not equal",
    },
    {
      value: "less_than",
      label: "Less than",
    },
    {
      value: "not_less_than",
      label: "Not less than",
    },
    {
      value: "greater_than",
      label: "Greater than",
    },
    {
      value: "not_greater_than",
      label: "Not greater than",
    },
  ],
  CONTINENTS: [
    {
      label: i18n.t("continents.af"),
      code: "AF",
    },
    {
      label: i18n.t("continents.as"),
      code: "AS",
    },
    {
      label: i18n.t("continents.na"),
      code: "NA",
    },
    {
      label: i18n.t("continents.sa"),
      code: "SA",
    },
    {
      label: i18n.t("continents.eu"),
      code: "EU",
    },
    {
      label: i18n.t("continents.oc"),
      code: "OC",
    },
    {
      label: i18n.t("continents.an"),
      code: "AN",
    },
  ],
  PROVINCES: [
    {
      label: i18n.t("provinces.province00"),
      code: "AS-VN-00",
    },
    {
      label: i18n.t("provinces.provinceNe"),
      code: "AS-VN-NORTHERN",
    },
    {
      label: i18n.t("provinces.provinceCe"),
      code: "AS-VN-CENTRAL",
    },
    {
      label: i18n.t("provinces.provinceSe"),
      code: "AS-VN-SOUTHERN",
    },
    { label: i18n.t("provinces.province01"), code: "AS-VN-01" },
    { label: i18n.t("provinces.province03"), code: "AS-VN-03" },
    { label: i18n.t("provinces.province05"), code: "AS-VN-05" },
    { label: i18n.t("provinces.province09"), code: "AS-VN-09" },
    { label: i18n.t("provinces.province13"), code: "AS-VN-13" },
    { label: i18n.t("provinces.province20"), code: "AS-VN-20" },
    { label: i18n.t("provinces.province21"), code: "AS-VN-21" },
    { label: i18n.t("provinces.province23"), code: "AS-VN-23" },
    { label: i18n.t("provinces.province24"), code: "AS-VN-24" },
    { label: i18n.t("provinces.province30"), code: "AS-VN-30" },
    { label: i18n.t("provinces.province32"), code: "AS-VN-32" },
    { label: i18n.t("provinces.province33"), code: "AS-VN-33" },
    { label: i18n.t("provinces.province34"), code: "AS-VN-34" },
    { label: i18n.t("provinces.province35"), code: "AS-VN-35" },
    { label: i18n.t("provinces.province37"), code: "AS-VN-37" },
    { label: i18n.t("provinces.province39"), code: "AS-VN-39" },
    { label: i18n.t("provinces.province43"), code: "AS-VN-43" },
    { label: i18n.t("provinces.province44"), code: "AS-VN-44" },
    { label: i18n.t("provinces.province45"), code: "AS-VN-45" },
    { label: i18n.t("provinces.province46"), code: "AS-VN-46" },
    { label: i18n.t("provinces.province47"), code: "AS-VN-47" },
    { label: i18n.t("provinces.province49"), code: "AS-VN-49" },
    { label: i18n.t("provinces.province50"), code: "AS-VN-50" },
    { label: i18n.t("provinces.province52"), code: "AS-VN-52" },
    { label: i18n.t("provinces.province53"), code: "AS-VN-53" },
    { label: i18n.t("provinces.province54"), code: "AS-VN-54" },
    { label: i18n.t("provinces.province55"), code: "AS-VN-55" },
    { label: i18n.t("provinces.province58"), code: "AS-VN-58" },
    { label: i18n.t("provinces.province59"), code: "AS-VN-59" },
    { label: i18n.t("provinces.province60"), code: "AS-VN-60" },
    { label: i18n.t("provinces.province61"), code: "AS-VN-61" },
    { label: i18n.t("provinces.province62"), code: "AS-VN-62" },
    { label: i18n.t("provinces.province63"), code: "AS-VN-63" },
    { label: i18n.t("provinces.province64"), code: "AS-VN-64" },
    { label: i18n.t("provinces.province65"), code: "AS-VN-65" },
    { label: i18n.t("provinces.province66"), code: "AS-VN-66" },
    { label: i18n.t("provinces.province67"), code: "AS-VN-67" },
    { label: i18n.t("provinces.province68"), code: "AS-VN-68" },
    { label: i18n.t("provinces.province69"), code: "AS-VN-69" },
    { label: i18n.t("provinces.province70"), code: "AS-VN-70" },
    { label: i18n.t("provinces.province71"), code: "AS-VN-71" },
    { label: i18n.t("provinces.province72"), code: "AS-VN-72" },
    { label: i18n.t("provinces.province73"), code: "AS-VN-73" },
    { label: i18n.t("provinces.province74"), code: "AS-VN-74" },
    { label: i18n.t("provinces.province75"), code: "AS-VN-75" },
    { label: i18n.t("provinces.province76"), code: "AS-VN-76" },
    { label: i18n.t("provinces.province77"), code: "AS-VN-77" },
    { label: i18n.t("provinces.province78"), code: "AS-VN-78" },
    { label: i18n.t("provinces.province79"), code: "AS-VN-79" },
    { label: i18n.t("provinces.province80"), code: "AS-VN-80" },
    { label: i18n.t("provinces.province81"), code: "AS-VN-81" },
    { label: i18n.t("provinces.province82"), code: "AS-VN-82" },
    { label: i18n.t("provinces.province83"), code: "AS-VN-83" },
    { label: i18n.t("provinces.province84"), code: "AS-VN-84" },
    { label: i18n.t("provinces.province85"), code: "AS-VN-85" },
    { label: i18n.t("provinces.province86"), code: "AS-VN-86" },
    { label: i18n.t("provinces.province87"), code: "AS-VN-87" },
    { label: i18n.t("provinces.province88"), code: "AS-VN-88" },
    { label: i18n.t("provinces.province89"), code: "AS-VN-89" },
    { label: i18n.t("provinces.province90"), code: "AS-VN-90" },
    { label: i18n.t("provinces.province91"), code: "AS-VN-91" },
    { label: i18n.t("provinces.province92"), code: "AS-VN-92" },
    { label: i18n.t("provinces.province93"), code: "AS-VN-93" },
    { label: i18n.t("provinces.provinceDefault"), code: "DEFAULT" },
  ],
  RESOURCE_OPTION: [10, 20, 30, 40, 50],
  BEM_START_CERTIFICATE: [
    "----BEGIN CERTIFICATE----",
    "-----BEGIN CERTIFICATE-----",
  ],
  BEM_END_CERTIFICATE: ["----END CERTIFICATE----", "-----END CERTIFICATE-----"],
  BEM_START_PRIVATE_KEY: [
    "----BEGIN PRIVATE KEY----",
    "----BEGIN RSA PRIVATE KEY----",
    "-----BEGIN PRIVATE KEY-----",
    "-----BEGIN RSA PRIVATE KEY-----",
  ],
  BEM_END_PRIVATE_KEY: [
    "----END PRIVATE KEY----",
    "----END RSA PRIVATE KEY----",
    "-----END PRIVATE KEY-----",
    "-----END RSA PRIVATE KEY-----",
  ],
};
